"use client";

import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { useAppContext } from "@components/Provider";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import Post from "src/constants/Post";

const DealsPageLayout = ({ children }) => {
  const { data, siteId, isMobile, subscriberCookie, isNonClosableModalChecked } = useAppContext();

  useEffect(() => {
    if (!data?.SiteSettings?.gtm_container_id) return;

    // Delay GTM init until layout and page state are stable
    const id = data.SiteSettings.gtm_container_id;

    requestAnimationFrame(() => {
      TagManager.initialize({ gtmId: id });
    });
  }, [data?.SiteSettings?.gtm_container_id]);

  return (
    <SingleColumnLayout
      siteId={siteId}
      isMobile={isMobile}
      subscriberCookie={subscriberCookie}
      isNonClosableModalChecked={isNonClosableModalChecked}
      postType={Post.TYPES.DEALS}
    >
      {children}
    </SingleColumnLayout>
  );
};

export default DealsPageLayout;
